import { render } from "./ScreenImage.vue?vue&type=template&id=ad053992&scoped=true"
import script from "./ScreenImage.vue?vue&type=script&lang=js"
export * from "./ScreenImage.vue?vue&type=script&lang=js"

import "./ScreenImage.vue?vue&type=style&index=0&id=ad053992&scoped=true&lang=css"

import exportComponent from "/mnt/data/workspace/risetai/riset.ai-website/Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad053992"]])

export default __exports__